import idx from 'idx'
import { subDays } from 'date-fns'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { animateScroll } from 'react-scroll'
import { downloadDataAsCsv } from 'utils/files'
import withMixpanel, { TRAP_DATA_FILTER, SCREEN_VIEW_TRAP_DATA_TRAPS, EXPORT_DATA_TRAP_REPORT } from 'utils/mixpanel'
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose'

// import { TRAP_DATA } from 'constants/form'
import { DATE_DROPDOWN_DEFAULT } from 'constants/tables'
import { isEqual, getPaginationObject } from 'utils/misc'

import * as mapModule from 'modules/map'
import * as trapModule from 'modules/trap'
import * as popoverModule from 'modules/popover'
import * as userActions from 'actions/userActions'
import * as uiActions from 'actions/uiActions'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        traps: idx(state, _ => _.traps.items),
        tableLoading: idx(state, _ => _.traps.loading),
        organisation: idx(state, _ => _.organisation.selected),
        showArchived: idx(state, _ => _.ui.showArchived)
      }
    },
    (dispatch) => {
      const actions = {
        ...mapModule,
        ...trapModule,
        ...userActions,
        ...popoverModule,
        ...uiActions,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    ({ showArchived }) => ({
      selectedRange: DATE_DROPDOWN_DEFAULT,
      filters: {
        dateLimit: subDays(new Date(), DATE_DROPDOWN_DEFAULT.value),
        search: '',
        pagination: {
          offset: 0, limit: 8
        },
        loaded: true,
        active: !showArchived,
      }
    }),
    {
      handleRangeChange: state => selectedRange => ({
        ...state,
        selectedRange,
        filters: {
          ...state.filters,
          dateLimit: subDays(new Date(), selectedRange.value),
          loaded: false,
          
        }
      }),
      onPageChange: state => (offset) => {
        return getPaginationObject(state, { offset }, false)
      },
      setPagination: state => ({ count }) => {
        return getPaginationObject(state, { count }, true)
      },
      setFilters: state => newFilters => ({
        ...state,
        filters: {
          ...state.filters,
          ...newFilters,
          loaded: false,
        }
      }),
    }
  ),
  withHandlers({
    onSearchChange: ({setFilters}) => (value) => {
      setFilters({search: [{key: 'trapName', value}]})
    },
    onTableSortClick: ({setFilters}) => (orderBy) => {
      setFilters({orderBy: [orderBy]})
    },
    onTableRowClick: ({actions}) => (row) => {
      actions.selectTrap(row, () => {
        actions.showPopover(popoverModule.TRAP_DETAILS)
      })
    },
    onToggle: ({actions}) => () => {
      actions.setToggle(true)
    },
    onTableSelectableClick: ({actions}) => (selectable) => {
      animateScroll.scrollTo(55, {duration: 500})
      setTimeout(() => {
        actions.focusTrap(selectable)
      }, 500)
    },
    onExportClick: ({
      track, actions, organisation
    }) => () => {
      actions.showPopover(popoverModule.EXPORT_DATA, {})
    },
    onRangeChange: ({ track, handleRangeChange }) => (selectedRange) => {
      track(TRAP_DATA_FILTER(selectedRange))
      handleRangeChange(selectedRange)
    }
  }),
  lifecycle({
    componentDidMount() {
      const { 
        track, actions, organisation, filters, setPagination
      } = this.props
      track(SCREEN_VIEW_TRAP_DATA_TRAPS)
      actions.getReportTraps(organisation, filters, setPagination)
    },
    componentDidUpdate(prevProps) {
      const { 
        actions, organisation, filters, setPagination, 
      } = this.props
      if (!isEqual(filters, prevProps.filters) && !filters.loaded) {
        actions.getReportTraps(organisation, filters, setPagination)
      }
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/traps/TrapDataOverview/TrapDataOverview.enhancer.js